import React from "react";

import { useTheme } from "../../../../../context/theme";
import { Height, Overflow, ResponsiveDimension } from "../../../../../types";
import { Box } from "../../../../layout";

export type Props = {
  children: React.ReactNode;
  scrollable?: boolean;
  padding?: ResponsiveDimension;
  overflowY?: Overflow;
  background?: string;
  maxHeight?: Height;
  roundedCorners?: boolean;
};

export default function MobileBottomSheetContent({
  children,
  scrollable = true,
  padding = "xxlarge",
  overflowY,
  background,
  maxHeight,
  roundedCorners = true
}: Props) {
  const theme = useTheme();

  return (
    <Box
      padding={padding}
      width="100%"
      maxHeight={maxHeight || "100%"}
      position="absolute"
      overflowY={overflowY || (scrollable ? "auto" : "hidden")}
      left="0"
      bottom="0"
      margin="auto"
      backgroundColor={theme.foreground}
      background={background}
      dataTest="MobileBottomSheet"
      borderTopLeftRadius={roundedCorners ? "12" : "none"}
      borderTopRightRadius={roundedCorners ? "12" : "none"}
    >
      {children}
    </Box>
  );
}
